import React from 'react'
import { Link } from 'react-router'
import Signup from '../components/Signup'

class Footer extends React.Component {
  render () {
    return (
      <footer className="footer">
        <div className="container">
          <div className="footer-row">
            <div className="footer-text">
              &copy; {new Date().getFullYear()} ScrimmageQA<br/>
              Made in Seattle 🌧 ☕️ 🌲<br/>
            </div>
            <Signup text="Want to keep in touch when we have updates? Sign up below."/>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ../components/Footer.js